/* Product page effects: 3D tilt on the main photo and scroll reveal for badges/tabs. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    var els = document.querySelectorAll('.pr-reveal');
    for (var i = 0; i < els.length; i++) { els[i].classList.add('is-in'); }
  }

  function init() {
    document.documentElement.classList.add('pr-js');

    var targets = document.querySelectorAll('.product-info--redesign .product-trust_item, .section-product-template .product-tabs');
    for (var i = 0; i < targets.length; i++) { targets[i].classList.add('pr-reveal'); }

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      for (var j = 0; j < targets.length; j++) { io.observe(targets[j]); }
      setTimeout(revealAll, 4000);
    }

    var media = document.querySelector('.product-info--redesign .product-media_main');
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (media && fine && !reduce) {
      media.addEventListener('pointermove', function (e) {
        var r = media.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = 'perspective(1000px) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 7) + 'deg)';
      });
      media.addEventListener('pointerleave', function () { media.style.transform = ''; });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
